<template>
    <div class="customerMain" id="bigdata">
        <div class="autoWidth">
            <div class="quanp">
                <el-button
                    id="fullScreen"
                    @click="showFullScreen"
                    type="primary"
                    >{{ onFullScreen ? "退出全屏" : "进入全屏" }}
                </el-button>
            </div>
            <div class="customerTop">
                <img
                    src="../../../assets/supervise/customerTitle.png"
                    alt=""
                    srcset=""
                />
                <div class="titleFirst"></div>
                <div class="titleSecond"></div>
                <h1>{{title.mechanismName}}养老可视化</h1>
            </div>
            <!-- tab切换 -->

            <!-- 切换内容 -->
            <div class="tabContent">
                <institution-home></institution-home>
            </div>
        </div>
    </div>
</template>

<script>
import institutionHome from "./institutionHome.vue"
export default {
    data() {
        return {
            customerIndex: 2,
            onFullScreen: false,
            title:{},
        }
    },
    components: {
        institutionHome,
    },
    created() {
        this.$store.commit("centerFull", false)
        this.customerIndex = 0
        if (sessionStorage.getItem("customerIndex")) {
            this.customerIndex = sessionStorage.getItem("customerIndex")
        }
        this.dataTitle()
    },
    mounted() {
        const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    methods: {
        // 获取标题
        dataTitle() {
            this.$http
                .request({
                    url: "/jgyl/admin/institute/info/findInstituteByUser",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.title = res.content
                    }
                })
        },
        // 模块切换
        changeTab(index) {
            this.customerIndex = index
            sessionStorage.setItem("customerIndex", index)
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
                this.$store.commit("centerFull", true)
            } else {
                this.$store.commit("centerFull", false)
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
                this.$store.commit("centerFull", true)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
    },
    destroyed() {
        sessionStorage.removeItem("customerIndex")
    },
}
</script>

<style lang='less' scoped>
.customerMain {
    position: relative;
    height: 100%;
    background: #021d36;
    .customerTop {
        img {
            width: 100%;
            height: 88px;
        }
        h1 {
            color: #6ebcff;
            position: absolute;
            text-align: center;
            font-weight: bolder;
            font-size: 35px;
            left: 0;
            top: 0;
            width: 100%;
            height: 78px;
            line-height: 78px;
            z-index: 3;
        }
        .titleFirst {
            min-width: 560px;
            position: absolute;
            width: 560px;
            border-top: 78px solid #1e69b6;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -310px;
            z-index: 2;
        }
        .titleSecond {
            min-width: 620px;
            width: 620px;
            position: absolute;
            border-top: 78px solid #103b71;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -340px;
        }
    }
    .autoWidth {
        max-width: 1920px;
        margin: auto;
        position: relative;
        height: 100%;
    }
    .customerTab {
        position: absolute;
        left: 0px;
        top: 92px;
        right: 0px;
        width: 100%;
        height: 40px;
        text-align: center;
        color: #4a6fb4;
        font-size: 16px;
        z-index: 999;
        span {
            display: inline-block;
            cursor: pointer;
            width: 120px;
            line-height: 38px;
            border: 2px solid rgba(46, 158, 255, 0.8);
            margin-right: 12px;
            border-radius: 5px;
            &.curIndex {
                background: #2889fe;
                color: #fff;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }
    .quanp {
        right: 10px;
        top: 15px;
        position: absolute;
        z-index: 100;
        .quanp button {
            padding: 10px;
        }
    }
}
</style>